import React from "react"
import ChipSwitch from "../../../../../ui/molecules/ChipSwitch"
import { CheckboxFilterOption, FilterCategory } from "../types"
import classes from "./FilterChips.module.css"

interface Props {
  filters: FilterCategory[]
  onOptionToggle: (option: CheckboxFilterOption) => void
}

const getTrueOption = (category: FilterCategory) =>
  (category.options as CheckboxFilterOption[]).find((x) => x.code === "true")

const isSelected = (category: FilterCategory) =>
  getTrueOption(category)?.selected ?? false

const FilterChips = ({ filters, onOptionToggle }: Props) => {
  const handleToggle = (category: FilterCategory) => {
    onOptionToggle(getTrueOption(category) as any)
  }

  const isActive = (category: FilterCategory) =>
    (getTrueOption(category)?.occurrences ?? 0) > 0

  return (
    <div className={classes.chipsContainer}>
      <div className={classes.chipsRow}>
        {filters.map((x) => (
          <div key={x.id} className={classes.chip}>
            <ChipSwitch
              label={x.name}
              value={isSelected(x)}
              onChange={() => handleToggle(x)}
              disabled={!isActive(x)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterChips
